
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-provider-package",
      function () {
        return require("private-next-pages/service-provider-package.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-provider-package"])
      });
    }
  